<div class="footer-sec">
    <p class="text-center text-gray-500 text-sm m-0">
        Developed by Webel Technology Limited.
    </p>
</div>